import React, { useState } from "react";

// Sticky pill quick-nav. top-0 is relative to the DashboardLayout scroll pane.
// All colors/spacing are inline styles (not Tailwind utilities) — this bar is
// function-critical, so it shouldn't depend on any one-off class rendering.
const StickySectionNav = ({ sections, activeId, onSelect }) => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        marginLeft: "-2rem",
        marginRight: "-2rem",
        marginBottom: "1.5rem",
        padding: "0.75rem 2rem",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "0.5rem",
          overflowX: "auto",
          paddingBottom: "2px",
        }}
      >
        {sections.map((s) => {
          const active = activeId === s.id;
          const hovered = hoveredId === s.id;
          return (
            <button
              key={s.id}
              onClick={() => onSelect(s.id)}
              onMouseEnter={() => setHoveredId(s.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.4rem",
                padding: "0.45rem 1rem",
                borderRadius: "9999px",
                fontSize: "0.8125rem",
                fontWeight: 600,
                whiteSpace: "nowrap",
                cursor: "pointer",
                transition: "all 150ms ease",
                background: active ? s.color : "#ffffff",
                color: active ? "#ffffff" : hovered ? s.color : "#475569",
                border: `1.5px solid ${active ? s.color : hovered ? s.color : "#e2e8f0"}`,
                boxShadow: active
                  ? `0 3px 10px -3px ${s.color}80`
                  : "0 1px 2px rgba(15, 23, 42, 0.04)",
                transform: active ? "translateY(-1px)" : "none",
              }}
            >
              <span style={{ display: "flex", color: active ? "#ffffff" : s.color }}>
                {s.icon}
              </span>
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StickySectionNav;
